import { ForgotForm, useAuthStore } from "@/features/auth";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function ForgotPage() {
  const isAuthorized = useAuthStore((s) => s.isAuthorized);
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    if (isAuthorized) {
      const returnUrl = new URLSearchParams(location.search).get("returnUrl");
      navigate(returnUrl || "/");
    }
  }, [isAuthorized]);

  return <ForgotForm />;
}
